/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiSearchIndex
 */
export interface ApiSearchIndex {
    /**
     * 
     * @type {string}
     * @memberof ApiSearchIndex
     */
    name: string;
    /**
     * 
     * @type {ApiSearchIndexTypeEnum}
     * @memberof ApiSearchIndex
     */
    type: ApiSearchIndexTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ApiSearchIndex
     */
    createdTime: Date;
}

/**
* @export
* @enum {string}
*/
export enum ApiSearchIndexTypeEnum {
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION',
    DOWJONES_SANCTION_NORMALISED = 'DOWJONES_SANCTION_NORMALISED',
    DOWJONES_SANCTION_NORMALISED_NGRAM_INDIVIDUAL = 'DOWJONES_SANCTION_NORMALISED_NGRAM_INDIVIDUAL',
    DOWJONES_PEP_NORMALISED = 'DOWJONES_PEP_NORMALISED',
    DOWJONES_PEP_NORMALISED_NGRAM = 'DOWJONES_PEP_NORMALISED_NGRAM',
    DOWJONES_ADVERSE_MEDIA_NORMALISED = 'DOWJONES_ADVERSE_MEDIA_NORMALISED',
    DOWJONES_ADVERSE_MEDIA_NORMALISED_NGRAM_INDIVIDUAL = 'DOWJONES_ADVERSE_MEDIA_NORMALISED_NGRAM_INDIVIDUAL',
    DOWJONES_ADVERSE_MEDIA_ENTITY_NORMALISED = 'DOWJONES_ADVERSE_MEDIA_ENTITY_NORMALISED',
    DOWJONES_ADVERSE_MEDIA_ENTITY_NORMALISED_NGRAM = 'DOWJONES_ADVERSE_MEDIA_ENTITY_NORMALISED_NGRAM'
}


/**
 * Check if a given object implements the ApiSearchIndex interface.
 */
export function instanceOfApiSearchIndex(value: object): value is ApiSearchIndex {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    return true;
}

export function ApiSearchIndexFromJSON(json: any): ApiSearchIndex {
    return ApiSearchIndexFromJSONTyped(json, false);
}

export function ApiSearchIndexFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSearchIndex {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'createdTime': (new Date(json['createdTime'])),
    };
}

export function ApiSearchIndexToJSON(json: any): ApiSearchIndex {
    return ApiSearchIndexToJSONTyped(json, false);
}

export function ApiSearchIndexToJSONTyped(value?: ApiSearchIndex | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': value['type'],
        'createdTime': value['createdTime'].toISOString(),
    };
}

